import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'arrowIconDropdown',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#387DFF",
  },
  width: {
    type: Number as PropType<number | string>,
    default: 10,
  },
  height: {
    type: Number as PropType<number | string>,
    default: 7,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: `${__props.width}`,
    height: `${__props.height}`,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none"
  }, [
    _createElementVNode("path", {
      d: "M0.104884 1.50645L4.67976 6.69269C4.72096 6.73624 4.77061 6.77093 4.82567 6.79463C4.88073 6.81834 4.94005 6.83057 5 6.83057C5.05995 6.83057 5.11927 6.81834 5.17433 6.79463C5.22939 6.77093 5.27904 6.73624 5.32024 6.69269L9.89512 1.50645C9.93169 1.46525 9.95972 1.4172 9.97757 1.36508C9.99541 1.31296 10.0027 1.25781 9.99909 1.20284C9.99458 1.14743 9.97901 1.09349 9.95329 1.0442C9.92758 0.994906 9.89224 0.951272 9.84937 0.915875L9.07996 0.271233C9.03793 0.234878 8.98904 0.207314 8.93618 0.19017C8.88332 0.173026 8.82756 0.16665 8.77219 0.171417C8.71709 0.175404 8.66333 0.190329 8.61406 0.215322C8.56479 0.240315 8.52099 0.274874 8.48522 0.316981L5.0707 4.24721C5.04968 4.26804 5.02128 4.27972 4.99168 4.27972C4.96209 4.27972 4.93369 4.26804 4.91266 4.24721L1.51478 0.316981C1.44755 0.236676 1.35249 0.184693 1.2486 0.171417C1.19352 0.166083 1.13793 0.171797 1.08508 0.188222C1.03223 0.204648 0.983193 0.231455 0.940838 0.267074L0.150633 0.915874C0.107763 0.951272 0.0724248 0.994905 0.0467083 1.0442C0.0209918 1.09349 0.0054186 1.14743 0.000909419 1.20284C-0.00273159 1.25781 0.00458484 1.31296 0.0224338 1.36508C0.0402828 1.4172 0.0683087 1.46525 0.104884 1.50645Z",
      fill: `${__props.color}`
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})